import * as React from "react";
import { Box, Button, Divider, Stack, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";


import { useState } from "react";
import RequestPage from "./RequestPage";
const Label = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  whiteSpace: "nowrap",
}));
export default function RequestMobile() {
  const navigate = useNavigate();
  const [assetPageCount, setAssetPageCount] = useState({
    request:0,
    warranty:0,
    task:0,
    calibration:0
  })


  const handleDataChange = (childData) => {

    setAssetPageCount({
      request:childData.request,
      warranty:childData.warranty,
      task:childData.task,
      calibration:childData.calibration
    });
  };


  const requestDashboardData = useSelector(
    (store) => store?.nbmData?.requestDashboardDataNBM
  );
  const warrantyStatusData = useSelector((store) => store.nbmData?.warrantyStatus);
  const warrantycount = warrantyStatusData ? warrantyStatusData.length : 0;
  const calibrationList = useSelector((store) => store.nbmData.calibratedList);
  const calibrationcount = calibrationList ? calibrationList.length : 0;


  return (
    <>
    <Stack
      sx={{
        width: "100%",
        // height: "100vh",
        marginTop:'-11px',
       
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        bgcolor: "#f5f5f5",
        gap: "30px",
        paddingBottom:'11px',
      }}>
      <Stack
        sx={{
         
          height: "130px",
          bgcolor: "#1B2535",
          width: "100%",
          color: "white",
        }}>
        <Stack
          justifyContent={"space-between"}
          sx={{ flexDirection: "row", p: 2, alignItems: "end", height: "90%" }}>
          <Label variant="h4">Request.</Label>
          <Label variant="h6" onClick={() => navigate("/calendar")}>Assign</Label>
        </Stack>
      </Stack>
      <Box
        sx={{
          width: "80%",
          height: "45%",

          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",

          gap: "10px",
        }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "50%",
            gap: "10px",
          }}>
          <Stack
            onClick={() => navigate("/request-mobile")}
            sx={{
              cursor: "pointer",
              width: "48%",
              height:'100px',
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
              p: 2,
              boxShadow: " 0px 0px 8px 0px #DBE7E5D9",
            }}>
            <Label variant="h6" sx={{ color: "#4690FF" }}>
            {requestDashboardData?.request_count}
            </Label>
            <Label variant="h6">Requests</Label>
          </Stack>
          <Stack
            onClick={() => navigate("/calendar")}
            sx={{
              width: "48%",
              height:'100px',
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
              p: 2,
              boxShadow: " 0px 0px 8px 0px #DBE7E5D9",
            }}>
            <Label variant="h6" sx={{ color: "#4690FF" }}>
            {warrantycount}
            </Label>
            <Label variant="h6">Warranty</Label>
          </Stack>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "50%",
            gap: "10px",
          }}>
          <Stack
            onClick={() => navigate("/task")}
            sx={{
              width: "48%",
              height:'100px',
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
              p: 2,
              boxShadow: " 0px 0px 8px 0px #DBE7E5D9",
            }}>
            <Label variant="h6" sx={{ color: "#4690FF" }}>
            {requestDashboardData?.task_count}
            </Label>
            <Label variant="h6">My tasks</Label>
          </Stack>
          <Stack
            onClick={() => navigate("/calendar")}
            sx={{
              width: "48%",
              height:'100px',
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
              p: 2,
              boxShadow: " 0px 0px 8px 0px #DBE7E5D9",
            }}>
            <Label variant="h6" sx={{ color: "#4690FF" }}>
            {calibrationcount}
            
            </Label>
            <Label variant="h6">Calibrations</Label>
          </Stack>
        </Box>
      </Box>
      <Divider sx={{ width: "90%" }} />
      <Button
        variant="contained"
        size="large"
        sx={{ borderRadius: "22px", width: "80%" }}
        onClick={() => navigate("/calendar")}>
        Calendar
      </Button>






    </Stack>



    <RequestPage  handleDataChange={handleDataChange} />
    </>
  );
}
